export default __webpack_public_path__ + "static/media/pdf-master-display.248a27ec.pdf";